import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useCoreApi } from '../../api';
import { coreKeys } from '../../query-key-factory';
import { CauseSplits } from '../types';

const useUpdateMyCausesSplits = () => {
  const CoreApi = useCoreApi();
  const queryClient = useQueryClient();

  const updateCauseSelections = async (causeSplits: CauseSplits) => {
    const { data } = await CoreApi.put(`/cause_selections/bulk_update`, {
      cause_selections: causeSplits,
    });
    return data;
  };

  return useMutation({
    mutationFn: updateCauseSelections,
    onSuccess() {
      void queryClient.invalidateQueries({ queryKey: coreKeys.user.causeSelection.all });
    },
  });
};

export { useUpdateMyCausesSplits };
